<div class="fullwidth">
    <p *ngIf="FileWindowDeadline && FileWindowDeadline.DateEnd"><strong>Deadline for submission: </strong><span>{{FileWindowDeadline.DateEnd | date:'EEEE, MMM. d, yyyy'}}</span></p>
    <div *ngIf="FileWindowOpen !== true"><strong>Note: </strong>The window for uploading the {{AttachmentType?.Description}} has closed. No files may be uploaded at this time.</div>
    <div *ngIf="FileWindowOpen === true && Instructions" [innerHTML]="Instructions | safeHTML"></div>
    <div *ngIf="FileWindowOpen === true && !Instructions" fxLayout="row" fxLayoutAlign="space-between start" class="margin-bottom">
		<p>
			Use the button provided below to upload a {{AttachmentType?.Description}} file for the nominee.
		</p>
    </div>
	<ul>
		<li *ngIf="HasMaxSize"> Submissions must be less than {{AttachmentType?.SizeLimit | fileSize:0}} in size.</li>
		<li *ngIf="HasMinSize"> Submissions must be greater than {{AttachmentType?.SizeLimit | fileSize:0}} in size.</li>
		<li *ngIf="HasResolution">Submissions have a resolution greater than {{AttachmentType?.Resolution}}.</li>
	</ul>
    <!-- Non data sourced table -->
    <table class="fullwidth mat-table margin-top">
        <thead>
            <tr class="mat-header-row">
                <th class="mat-header-cell">File Name</th>
                <th class="mat-header-cell">Original Name</th>
                <th class="mat-header-cell mat-column-FileSize">File Size</th>
                <th class="mat-header-cell mat-column-DateUploaded">Date Uploaded</th>
                <th class="mat-header-cell mat-column-UploaderName">Uploader</th>
                <th class="mat-header-cell mat-column-FileStatus">Status</th>
                <th class="mat-header-cell mat-column-Actions">Action(s)</th>
            </tr>
        </thead>
        <tbody>
            <tr class="mat-row" *ngFor="let file of Files">
                <td class="mat-cell">{{file.FileName}}</td>
                <td class="mat-cell">{{file.OriginalFileName}}</td>
                <td class="mat-cell"><span>{{file.FileSize | fileSize}}</span></td>
                <td class="mat-cell">
                    <div>{{file.DateUploaded | datefns:'M/d/yyyy'}}</div>
                    <div>{{file.DateUploaded | datefns:'h:mm a'}}</div>
                </td>
                <td class="mat-cell"><span>{{file.UploaderName | titleCase}}</span></td>
                <td class="mat-cell">
                    <span *ngIf="file.FileStatus !== 'Uploading'">{{file.FileStatus}}</span>
                    <div *ngIf="file.FileStatus === 'Uploading'" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="10px">
                        <span>{{file.FileStatus}} ({{file.UploadPercentComplete}}%)</span>
                    </div>
                    <div *ngIf="file.IsInProgress" [@fadeInOut]="file.IsInProgress">
                        <mat-progress-bar mode="determinate" color="primary" class="fullwidth" [value]="file.UploadPercentComplete"></mat-progress-bar>
                    </div>
                </td>
                <td class="mat-cell">
                    <button type="button" *ngIf="FileWindowOpen === true" mat-raised-button color="primary" (click)="RemoveFile(file)">Remove File</button>
                    <!--<button type="button" *ngIf="CanDownload" mat-raised-button color="accent" (click)="DownloadFile(file)">Download</button>-->
                </td>
            </tr>
            <tr *ngIf="NoData">
                <td class="mat-cell" colspan="7">
                    <span><em>No {{FileTypeName}} files have been uploaded for this nominee.</em></span>
                </td>
            </tr>
        </tbody>
    </table>

    <div fxLayout="row" style="margin-top: 20px">
        <button mat-raised-button color="primary" type="button" (click)="DownloadFile()" style="margin-right: 15px" *ngIf="AttachmentType?.DownloadFile">Download Blank Consent Form</button>
        <app-file-uploader *ngIf="FileWindowOpen === true" color="primary" [buttonText]="'Upload ' + AttachmentType?.Name" [validExtensions]="AttachmentType?.ExtensionList" (upload)="HandleUpload($event)"></app-file-uploader>
    </div>
</div>